import * as style from './SustainableCorner.module.css';

export function SustainableCorner() {
    return <div className={style.sustainableCorner}></div>;
}
